import {Provider} from 'jotai';
import React from 'react';
import ConfigProvider from '../ConfigProvider';
import Config from '../../config';
import zhCN from 'antd/lib/locale/zh_CN';
import {isChrome} from '../../Utils/common';
import {MainAppContext} from './context';
import Boundary from '../Boundary';
import {AppMenuItem} from '../../MainMenu';

const BrowserTip = React.lazy(() => import('./Components/BrowserTip'));

interface AppWrapperProps {
    menuItems: AppMenuItem[];
    children: React.ReactNode;
}

export default function AppWrapper({menuItems, children}: AppWrapperProps) {
    if (!isChrome())
        return (
            <Boundary>
                <BrowserTip />
            </Boundary>
        );

    return (
        <MainAppContext.Provider value={{menuItems}}>
            <ConfigProvider
                locale={zhCN}
                topOffset={Config.topOffset}
                containerWidth={Config.containerWidth}>
                <Provider scope="root">{children}</Provider>
            </ConfigProvider>
        </MainAppContext.Provider>
    );
}
